export default "__VITE_ASSET__98404744__"